import React from 'react';
import PropTypes from 'prop-types';

import { useConfig } from 'Context/ConfigContext';

import VideoOverlayContent from './VideoOverlayContent';
import AutoNextSubsectionContent from './AutoNextSubsectionContent';
import { VIDEO_VARIANTS } from './constant';

const VideoOverlay = ({
  active,
  isShowOverlay,
  isLastSubsectionInCourse,
  currentSubsectionTitle,
  nextSubsectionTitle,
  variant,
  videoSize,
  onReplayClick,
  onNextSubsectionClick,
  onResumeClick,
  onCancelClick,
  ...props
}) => {
  const { classroom } = useConfig();
  const enableAutoNextSubsectionOnVideoEnd =
    classroom?.autoNextSubsectionOnVideoEnd?.enable ?? false;

  if (enableAutoNextSubsectionOnVideoEnd) {
    return (
      <AutoNextSubsectionContent
        active={active}
        isShowOverlay={isShowOverlay}
        isLastSubsectionInCourse={isLastSubsectionInCourse}
        currentSubsectionTitle={currentSubsectionTitle}
        nextSubsectionTitle={nextSubsectionTitle}
        variant={variant}
        videoSize={videoSize}
        onReplayClick={onReplayClick}
        onNextSubsectionClick={onNextSubsectionClick}
        onResumeClick={onResumeClick}
        onCancelClick={onCancelClick}
        {...props}
      />
    );
  }

  return (
    <VideoOverlayContent
      active={active}
      currentSubsectionTitle={currentSubsectionTitle}
      nextSubsectionTitle={nextSubsectionTitle}
      variant={variant}
      videoSize={videoSize}
      onReplayClick={onReplayClick}
      onNextSubsectionClick={onNextSubsectionClick}
      onResumeClick={onResumeClick}
      {...props}
    />
  );
};

VideoOverlay.propTypes = {
  active: PropTypes.bool,
  isShowOverlay: PropTypes.bool,
  isLastSubsectionInCourse: PropTypes.bool,
  currentSubsectionTitle: PropTypes.string,
  nextSubsectionTitle: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(VIDEO_VARIANTS)).isRequired,
  onReplayClick: PropTypes.func,
  onNextSubsectionClick: PropTypes.func,
  onResumeClick: PropTypes.func,
  onCancelClick: PropTypes.func,
};

VideoOverlay.defaultProps = {
  active: false,
  onReplayClick: () => {},
  onNextSubsectionClick: () => {},
  onResumeClick: () => {},
  onCancelClick: () => {},
};

export default VideoOverlay;
